import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { CultureSection } from './components/CultureSection';
import { ContactSection } from './components/ContactSection';
import { MarqueeStrip } from './components/MarqueeStrip';
import { StickyCTA } from './components/StickyCTA';
export function App() {
  return <div className="min-h-screen bg-tux-dark text-white relative" data-id="element-0">
      <Navbar data-id="element-1" />
      <StickyCTA data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <MarqueeStrip data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <CultureSection data-id="element-7" />
      </main>
      <ContactSection data-id="element-8" />
    </div>;
}